import './App.css';
import Kajak from "./components/Kajak";


function App() {
  return (
    <div>
    <Kajak />
    </div>
  );
}

export default App;


